import { render, staticRenderFns } from "./CompetitionsPage.vue?vue&type=template&id=ed88e44e&"
import script from "./CompetitionsPage.vue?vue&type=script&lang=js&"
export * from "./CompetitionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CompetitionsPage.vue"
export default component.exports